import React, { useEffect } from "react";
import SuccessPage from "../components/SuccessPage";
import { useParams, useNavigate } from "react-router-dom";
import { sendPostRequest } from "../utils";

const Success = () => {
  const { session_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!session_id) return;

    const setSubscription = async () => {
      try {
        const res = await sendPostRequest("set-subscription", { session_id });
        const data = await res.json();
        if (data?.subscriptionId) {
          navigate("/success", { replace: true });
        }
      } catch (err) {
        // silent — user already paid; just show the success page
      }
    };

    setSubscription();
  }, [session_id, navigate]);

  return <SuccessPage />;
};

export default Success;
